import { TrackingHandler } from '../TrackingHandler';
import { Listener } from './Listener';
import { deleteCookie, getCookie, setCookie } from '../../helpers/cookies';
export class SessionStorageListener extends Listener {
    cookiesAccepted = false;
    visitTimestamp;
    constructor() {
        super();
        const visitTimestamp = getCookie('visitTimestamp') || window.sessionStorage.getItem('visitTimestamp');
        this.visitTimestamp = visitTimestamp ? parseInt(visitTimestamp) : window.trackingHandler.viewTimestamp;
    }
    setConsent(eventId, essential, functional, marketing) {
        if (!functional && this.cookiesAccepted) {
            this.clearSessionStorage();
        }
        if (functional && !this.cookiesAccepted) {
            this.persistSessionStorage();
        }
        this.cookiesAccepted = functional;
    }
    clearSessionStorage() {
        window.sessionStorage.clear();
        deleteCookie('trackingData', { path: '/' });
        deleteCookie('visitTimestamp', { path: '/' });
    }
    persistSessionStorage() {
        const trackingHandler = TrackingHandler.getInstance();
        window.sessionStorage.setItem('trackingData', JSON.stringify(trackingHandler.getSessionTrackingData()));
        window.sessionStorage.setItem('visitTimestamp', this.visitTimestamp.toString());
        setCookie('trackingData', JSON.stringify(trackingHandler.getSessionTrackingData()), { path: '/' });
        setCookie('visitTimestamp', this.visitTimestamp.toString(), { path: '/' });
    }
}
